<template>
  <ul>
    <li v-if="shift.hasTravelBonus">
      ${{ bonusAmount('travel') }} travel bonus
    </li>
    <li v-if="showCallInBonus">
      ${{ bonusAmount('callIn') }} call-in bonus
    </li>
    <li v-if="shift.hasStraightBonus">
      ${{ bonusAmount('straight') }} client-added bonus
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BonusList',
  props: [
    'shift',
    'role',
  ],
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    showCallInBonus: function () {
      if (this.shift.hasCoverBonus && this.role == 'client') {
        return false;
      } else if (this.shift.hasCallInBonus) {
        return true;
      }
      return false;
    },
    hasBonus: function () {
      const has = eval(`this.shift.has${ this.type.charAt(0).toUpperCase() + this.type.slice(1) }Bonus`)
      return has
    },
    color: function () {
      if (this.hasBonus) {
        return 'grey darken-2'
      } else {
        return 'grey lighten-2'
      }
    },
    bonusIcon: function () {
      if (this.type == 'travel') {
        return "directions_car"
      } else if (this.type == 'callIn') {
        return "phone"
      } else {
        return "local_atm"
      }
    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      example: 'test'
    }
  },
  methods: {
    bonusAmount: function (bonusType) {
      const amount = eval(`this.shift.${ bonusType }BonusAmountDecimal`)
      const parsedAmount = parseInt(amount.replace(/,/g, '')) // remove commas!

      const twoThirds = (2/3)
      const twoThirdsAmount = parsedAmount * twoThirds

      if (this.role == 'employee') {
        return Math.trunc(twoThirdsAmount) // round down to whole dollar
      } else {
        return parsedAmount
      }
    },
  },
}
</script>

<style scoped>
</style>
